<template>
    <sub-page :title="title" class="m-myTopicAdd" :closeBtn="false">
        <div class="topic-page-frame">
            <!-- type: 1单、2多、3判、5DR、6CT -->
            <el-radio-group
                v-model="topicType"
                v-if="!id"
                fill="#2e7faa"
                class="topic-type">
                <el-radio-button :label="1">{{$t('paper.single')}}</el-radio-button>
                <el-radio-button :label="2">{{$t('paper.multiple')}}</el-radio-button>
                <el-radio-button :label="3">{{$t('paper.trueOrFalse')}}</el-radio-button>
                <el-radio-button label="MatchingTopic" v-if="$i18n.locale==='zh-CN'">{{$t('paper.matching')}}</el-radio-button>
                <el-radio-button label="DRTopic">DR</el-radio-button>
                <el-radio-button label="CTTopic">CT</el-radio-button>
            </el-radio-group>

            <div class="topic-container">
                <component
                    :is="componentName"
                    :topicID="id"
                    :theoryType="theoryType"
                ></component>
            </div>
        </div>
    </sub-page>
</template>

<script>
    import SubPage from '@/components/Subpage.vue';
    import TheoryTopic from './Components/TheoryTopic.vue';
    import DRTopic from './Components/DRTopic.vue';
    import CTTopic from './Components/CTTopic.vue';
    import MatchingTopic from './Components/MatchingTopic.vue';

    export default {
        props: ['id', 'type'],
        data() {
            return {
                title: '',
                topicType: 1,
                theoryType: 1,  //理论题类型：1单选、2多选、3判断,4配对题
            }
        },
        created() {

            if (this.id && this.type) {
                this.title = [this.$t('paper.single'), this.$t('paper.multiple'), this.$t('paper.trueOrFalse'), this.$t('paper.matching'), 'DR', 'CT'][this.type-1] + this.$t('c.edit');
            }

        },
        computed: {
            componentName() {
                let component = this.topicType;

                // 编辑模式
                if (this.id && this.type) {

                    if ([1,2,3].indexOf(~~this.type) > -1) {
                        this.theoryType = ~~this.type;
                        component = 'TheoryTopic'
                    } else {
                        component = {4: 'MatchingTopic',5: 'DRTopic', 6: 'CTTopic'}[this.type];
                    }

                } else {

                    // 添加模式，值为1、2、3均用'TheoryTopic'
                    if (Number.isInteger(this.topicType)) {
                        this.theoryType = this.topicType;
                        component = 'TheoryTopic'
                    }
                }

                return component;
            },
        },
        methods: {

        },
        watch: {},
        destroyed() {
            this.$emit('updateData');
        },
        components: {
            SubPage,
            TheoryTopic,
            DRTopic,
            CTTopic,
            MatchingTopic
        }
    }
</script>

<style scoped lang="scss">
    @import "../../style/const";

    .topic-page-frame {
        margin: 0 10px 7px 17px;
        border: solid 1px #ccc;
    }

    .topic-type {
        width: 100%;
        margin-left: -1px;
        border-bottom: 1px solid #ccc;
    }

    .topic-container {
        margin-top: 30px;
        margin-left: 10px;
    }
</style>
<style lang="scss">
    @import "../../style/const";

    .m-myTopicAdd {

        .topic-type {
            .el-radio-button .el-radio-button__inner {
                width: 120px;
                border-radius: 0;
                border-width: 0 1px 0 1px;
                border-color: #ccc;
                color: $c-txt;
                &:hover {
                    color: #22B9FF;
                }
            }
            .el-radio-button__orig-radio:checked + .el-radio-button__inner {
                color: #fff;
            }
        }
        .el-card.is-always-shadow{
            min-height: 100%;
        }

    }

    .el-card__header {
        + .el-card__body {
            > .topic-page-frame {
                border: none;
            }

            .topic-container {
                // margin-top: 10px;
            }
        }
    }


    .app-root:not(.lang-zh-CN) .m-myTopicAdd {
        .el-radio-button .el-radio-button__inner {
            width: auto;
            min-width: 200px;
        }
    }
</style>
